import React, { CSSProperties } from 'react';

export type IconProps = {
    width?: any;
    height?: any;
    viewBox?: string;
    style?: CSSProperties;
    iconClass?: string;
    className?: string;
    color?: string;
    [key: string]: any;
};

export function IconWrap({
    width,
    height,
    viewBox,
    style,
    className,
    iconClass,
    children,
    ...restProps
}: IconProps & { children: any }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? 8}
            height={height ?? 15}
            viewBox={viewBox || '0 0 8 15'}
            fill="none"
            style={style}
            className={`app-icon ${(iconClass && `app-icon-${iconClass}`) || ''} ${className || ''}`}
            {...restProps}
        >
            {children}
        </svg>
    );
}
